import React from 'react';
import Navigator from './navigator';

export default class ItemDialog extends React.Component {
	constructor(props) {
		super(props);
		console.log(props);
	}

	changeItem(item) {
		this.props.items.forEach(item => item.active = false);
		item.active = true;
		this.props.onChange(item);
		this.setState();
	}

	render() {
		return (
			<div>
				<div className="element--image-gallery--dialog--backdrop" onClick={() => this.props.onClose()} />
				<div className="element--image-gallery--dialog">
					<div className="element--image-gallery--dialog--image">
						{this.props.items.filter(item => item.active).map(item =>
							<div className="inner">
								{ item.rendered }
								<a href="javascript:void(0);" onClick={() => this.props.onClose()} className="close-btn">
									<i className="fa fa-window-close" aria-hidden="true" />
								</a>
							</div>
						)}
					</div>
					<Navigator items={this.props.items} onChange={item => this.changeItem(item)} />
				</div>
			</div>
		)
	}
}
